module.exports = __webpack_public_path__ + "static/media/hilda fight gear.3d32b359.png";